import { render, staticRenderFns } from "./UpdSearch.vue?vue&type=template&id=18775540"
import script from "./UpdSearch.vue?vue&type=script&lang=js"
export * from "./UpdSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports